export default "__VITE_ASSET__4AadbJtJ__"